<template>
  <PasswordReset v-if="$route.query.token"/>
  <PasswordMain v-else/>
</template>

<script>
  import PasswordMain from "../components/password/PasswordMain";
  import PasswordReset from "../components/password/PasswordReset";

  export default {
    name: "Password",
    components: {PasswordMain, PasswordReset}
  }
</script>

<style scoped>

</style>
